<mat-card>
  <mat-card-header class="card-header">
    <span class="warning-icon-wrapper">
      <mat-icon class="warning-icon">warning</mat-icon>
      <span class="exclamation">!</span>
    </span>
    <span>SNSアカウントの再連携をお願いします</span>
  </mat-card-header>
  <mat-card-content>
    <div>
      <p class="content">
        お客様が連携されている以下のSNSアカウントで、パスワード変更などの理由により、Cuepidからの情報取得ができなくなっております。
      </p>
      <p class="content">▼ 該当するSNS</p>
      <div class="content sns-tag-container">
        <button
          mat-raised-button
          [disabled]="true"
          [ngClass]="
            data.influencer.instagram_account?.need_reconnect
              ? 'btn-need-reconnect'
              : ''
          "
          class="btn"
        >
          Instagram
        </button>
        <button
          mat-raised-button
          [disabled]="true"
          [ngClass]="
            data.influencer.tiktok_account?.need_reconnect
              ? 'btn-need-reconnect'
              : ''
          "
          class="btn"
        >
          TikTok
        </button>
      </div>
      <p>
        お手数ですが、プロフィール編集画面から再連携の手続きをお願いいたします。
      </p>
    </div>
  </mat-card-content>
  <mat-card-footer>
    <div fxLayout="row" fxLayoutAlign="end">
      <button class="btn cancel-btn" (click)="close()" mat-raised-button>
        閉じる
      </button>
      <button
        class="submit-btn"
        (click)="goToReconnect()"
        mat-raised-button
        color="primary"
      >
        プロフィールを編集
      </button>
    </div>
  </mat-card-footer>
</mat-card>
